/* eslint-disable */
import React from 'react';
import { isDev } from '../../utils/CommonUtils';

// lms-qfix BE env (k8s-review.yaml) expects this client id; the CI variable
// REACT_APP_GOOGLE_OAUTH_CLIENT_ID is not set for that pipeline, so without an
// env-specific override the FE bundle would ship with the old hardcoded
// fallback below and every Google login would fail with an audience mismatch.
// Scoped to qfix only — prod keeps the historical fallback path untouched.
const DEV_GOOGLE_AUTH_CLIENT_ID =
  '904037670852-k13pdd6sphomk2gv3917q5vufht9ivcs.apps.googleusercontent.com';
const DEFAULT_GOOGLE_AUTH_CLIENT_ID =
  '104176560344-vjgtqbi1ga22rf4646q2pvrj73okfagb.apps.googleusercontent.com';

class App_data extends React.Component {
  constructor(props) {
    super(props);
    this.backend_api = process.env.REACT_APP_API_ENDPOINT;
    this.frontend_url = process.env.REACT_APP_FRONTEND_ENDPOINT;
    this.baseURL = process.env.REACT_APP_BASEURL;
    this.stripe_key = process.env.REACT_APP_STRIPEKEY;
    this.googleAuthClientID =
      process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID ||
      (isDev ? DEV_GOOGLE_AUTH_CLIENT_ID : DEFAULT_GOOGLE_AUTH_CLIENT_ID);
  }
}

export default new App_data();



// WEBPACK FOOTER //
// ./src/views/config/App_data.js